import React from "react";

const ShutDown = () => {
  return (
    <div>
      <p>September 28, 2026</p>
      <h2>Why I Shut Down My $10M Startup</h2>

      <p>
        This year on September 22nd, 2026, I FaceTimed my mom to wish her a
        happy birthday. Halfway through the call, she brought up that last year,
        I didn't call her or text her happy birthday. The worst part is, I
        didn't even remember. How did we get here?
      </p>

      <h2>Silicon Valley Cults</h2>
      <p>
        Hi, my name is Zinnie, I studied computer science at Vanderbilt and when
        I was 24, I started at Harvard Law School. I managed to make it through
        all of one semester before I joined a little-known cult called Prod and
        decided to “drop out” (take a leave of absence) from Harvard to form my
        own cult, a startup called Enttor.
      </p>

      <p>
        If you don't know much about Silicon Valley startup culture, all you
        need to know is that it's all-consuming. The last 18 months of my life
        have been a seemingly never ending roller coaster. It was the hardest
        I’ve ever worked in my entire life, 7 days a week, from the moment my
        alarm went off to the moment I passed out. I downed the Silicon Valley
        hustle culture Kool-Aid. Sweetgreen delivered by UberEats to my FiDi
        home office made up the rest of my diet so every spare minute could be
        spent working. Oftentimes, I would fall asleep on my floor after
        midnight without brushing my teeth and miss my 8AM Sam Y Soulcycle class
        in Noho. Work was the drug and somewhere along the way, my personal
        relationships went missing. A few of my close friends told me it was
        very difficult to be friends with me during this time because I never
        reached out.
      </p>

      <h2>The Highest of Highs</h2>
      <p>
        Before you dismiss me as crazy, have you ever had 6 figures hit your
        bank account in seconds and your documented net worth jump to $10M on a
        single day?
      </p>

      <p>
        On May 3, 2025, I closed our first institutional check, meaning money
        from an actual venture capital firm, not my mom, friends, or family.
        When the wire hit our bank account, me and my team just stared at our
        Mercury account in silent shock.
      </p>

      <p>
        Then the wire cleared, and so did the high. There's no other way to say
        it nicely. My team and I ate shit for at least the first 6 months.
      </p>

      <h2>18 Months in Pivot Hell</h2>
      <p>
        In startup land, a "pivot" is when you change what your company does
        because the current product isn't working. We were stuck in pivot hell
        for 18 months. We pivoted within the marketing industry and built 4
        different products. Some of them never made a dollar, one of them made
        thousands a month. In the last version of Enttor, we ran Facebook ads
        for Seed - Series A tech startup (because all my friends were early
        stage tech founders who sucked at marketing). The worst part about pivot
        hell is when things are kind of working so you brute force progress with
        little reward. Any entrepreneur will tell you, pivot hell is extremely
        demoralizing.
      </p>

      <p>
        During this time, I was forced to grow professionally faster than I ever
        had before. I was learning enterprise sales, marketing, fundraising,
        engineering, and leadership on the job, all at the exact same time. This
        was hard, even for someone who learns quickly. One day in startup land
        is equivalent to three days in the normal human world.
      </p>

      <h2>Shooting My Baby in the Backyard</h2>
      <p>
        Every quarter, founders send their investors an update on how the
        company is doing. When I sat down to write our Q2 2026 update, I looked
        at our cash in the bank, and I looked at our projected revenue. I knew
        it was unlikely we would 1,000x our investors' capital, and that's what's
        expected from venture-backed tech startups. Investors aren't looking for
        steady returns they could find elsewhere in the S&P 500. They're looking
        for the one outlier that returned their entire fund multiple times over.
      </p>

      <p>
        Some of our investors were personal. Four friends from Harvard and three
        from Vanderbilt. Instead of burning through the rest of the capital out
        of ego or recklessness, I decided it would be better to return capital
        and preserve relationships where possible. I dreaded making the phone
        calls to tell my friends, who were my first believers, that I had let
        them down. It was humiliating and heartbreaking.
      </p>

      <h2>The Practical Reasons for Why We Failed</h2>
      <p>
        It's funny how many YouTube videos, podcasts, and essays you can read
        about how to found a startup, what not to do, and yet you'll still make
        every single mistake all the internet advice warns you about. There are
        a plethora of reasons why Enttor didn't work out. They are intertwined
        and messy but here are the main 3.
      </p>

      <ol>
        <li>
          <b>No founder-market fit.</b> Founder-market fit means you're the
          right person to solve a problem. Every founder has their own unique
          set of superpowers. Ours had nothing to do with marketing. We were
          competing against offshore marketing agencies with years of Meta Ads
          experience and comically low pricing. Our gigachad advantage was so
          painfully obvious. In the last 2 weeks of operating Enttor, we started
          cold emailing lawyers from my Harvard Law email, and we could easily
          book 1 to 3 calls a day. We had an insane edge in the legal industry
          and we weren't even using it.
        </li>
        <li>
          <b>No co-founders.</b> I tried working with 4 different co-founders
          and it didn't work out for various reasons. One of my former
          co-founders even pretended he had hired a non-existent lawyer, which
          prompted me to hire Big Law attorneys and rack up an $8,000 bill.
        </li>
        <li>
          <b>Technology in search of a problem.</b> This is one of the most
          common pitfalls amongst technical founders. This is when you create a
          new technology first, do some mental cartwheels, and invent a use for
          it later. Unless your shiny tech gadget can print millions, you don’t
          have product-market-fit. Throw it in the garbage immediately before
          you get more emotionally attached. You’re supposed to start with your
          customer’s painful problem first and create a technology solution
          around it.
        </li>
      </ol>

      <h2>What’s Next</h2>
      <p>
        I made the decision to close Enttor on a Saturday in July in Bogota,
        Colombia on Kevin (my Founding Engineer’s) front porch. I didn’t know what was next but naturally, everyone wanted to know. For
        a while, I kept saying I was going to build another startup. But I
        didn't want my next company to be a knee-jerk response to my first startup
        not being a unicorn. So I did what any 20-something-year-old having a midlife crisis does. Go
        to graduate school. Conveniently, Harvard Law welcomed me back with open
        arms so I get to use the next year to appear productive but secretly
        taking a sabbatical to figure out what the f I'm doing with my life and
        my career.
      </p>

      <h2>A Closing Note</h2>
      <p>
        If I can leave you with one closing note, it would be this. Despite all
        my failures, I deeply believe, if you are in your 20s, you must take the
        big swing.
      </p>

      <p>Just don’t forget to call your mom on her birthday.</p>
    </div>
  );
};

export default ShutDown;
